export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-400-normal.woff2?361f3dbb9db6a59803265646720a9ae7";